import './ExperiencesPage.css'
import { Grid, Typography } from '@mui/material';
import { experienceInformation } from '../../information/information';
import ProjectsShowCase from '../../components/ProjectsShowCase/ProjectsShowCase';
import InternshipShowCase from '../../components/InternshipShowCase/InternshipShowCase';
import React, { useState } from 'react';
import ProjectShowCaseDetail from '../../components/ProjectShowCaseDetail/ProjectShowCaseDetail';
import { Internship, Project } from '../../interfaces/InformationInterface';

function ExperiencesPage() {
  let {article,projects,unrelated_projects,volunteers} = experienceInformation;
  unrelated_projects.forEach((projectGroup)=>{
    projects = [...projects,...projectGroup.projects]
  })
  const [informDetail,setInform] = useState<Internship|Project|null>(null);
    return <div id="ExperiencesPage">
    <ProjectShowCaseDetail hide={informDetail==null} onClose={()=>setInform(null)} information={informDetail}/>
    <Grid container direction={"column"} spacing={1} gap={"20px"}>
      <Grid item className="article">
        <Grid container direction={"column"} spacing={3} style={{paddingRight:"10px"}}>
          <Grid item>
            <Typography variant="h3" className="title">
              {article.title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" className="about_paragraph">
              {article.paragraph}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container justifyContent={"center"} direction={"column"} gap={"5px"}>
          <Grid item><Typography textAlign={"center"} variant='h5'>Projects</Typography></Grid>
          <Grid item><ProjectsShowCase onClick={(project)=>setInform(project)} justifyContent='center' projects={projects}/></Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container justifyContent={"center"} direction={'column'} gap={"5px"}>
          <Grid item><Typography textAlign={"center"} variant='h5'>Internships</Typography></Grid>
          <Grid item><InternshipShowCase onClick={(intern)=>setInform(intern)} justifyContent='center' internships={volunteers}/></Grid>
        </Grid>
      </Grid>
    </Grid>
  </div>;
}

export default ExperiencesPage;